import { render, staticRenderFns } from "./cangchuRk.vue?vue&type=template&id=42727914&scoped=true&"
import script from "./cangchuRk.vue?vue&type=script&lang=js&"
export * from "./cangchuRk.vue?vue&type=script&lang=js&"
import style0 from "./cangchuRk.vue?vue&type=style&index=0&id=42727914&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42727914",
  null
  
)

export default component.exports